import {
  FETCH_ANM_PROFILE_SUCCESS,
  FETCH_ANM_PROFILE_ERROR,
  FETCH_ANM_PROFILE,
  FETCH_ANM_ASHA_LIST,
  FETCH_ANM_ASHA_LIST_SUCCESS,
  FETCH_ANM_ASHA_LIST_FAILURE,
  FETCH_ANM_ACTIVITY_INCENTIVE,
  FETCH_ANM_ACTIVITY_INCENTIVE_SUCCESS,
  FETCH_ANM_ACTIVITY_INCENTIVE_FAILURE,
  FETCH_ANM_APPROVED_PENDING_REQUESTS,
  FETCH_ANM_APPROVED_PENDING_REQUESTS_SUCCESS,
  FETCH_ANM_APPROVED_PENDING_REQUESTS_FAILURE,
} from "./AshaAnmSectionActions";

const defaultState = {
  isLoading: false,
  anmProfile: {},
  listOfAshas: [],
  anmActivityIncentive: [],
  allRequests: [],
  // anmSchemes:{},
  // anmOnIncentives: [],
  // incentiveData:[]
};

const AnmSectionReducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_ANM_PROFILE:
    case FETCH_ANM_PROFILE_ERROR:
      return { ...state, isLoading: true, anmProfile: {} };
    case FETCH_ANM_PROFILE_SUCCESS:
      return { ...state, isLoading: false, anmProfile: action.payload };
    case FETCH_ANM_ASHA_LIST:
      return { ...state, isLoading: true };
    case FETCH_ANM_ASHA_LIST_SUCCESS:
      return { ...state, isLoading: false, listOfAshas: action.payload };
    case FETCH_ANM_ASHA_LIST_FAILURE:
      return { ...state, isLoading: false };
    case FETCH_ANM_ACTIVITY_INCENTIVE:
      return { ...state, isLoading: true };
    case FETCH_ANM_ACTIVITY_INCENTIVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        anmActivityIncentive: action.payload,
      };
    case FETCH_ANM_ACTIVITY_INCENTIVE_FAILURE:
      return { ...state, isLoading: false };
    case FETCH_ANM_APPROVED_PENDING_REQUESTS:
      return { ...state, isLoading: true };
    case FETCH_ANM_APPROVED_PENDING_REQUESTS_SUCCESS:
      return { ...state, isLoading: false, allRequests: action.payload };
    case FETCH_ANM_APPROVED_PENDING_REQUESTS_FAILURE:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};
export default AnmSectionReducer;
